import React from "react";

const DisplayStartMsg = () => {
  return (
    <div className="flex flex-col items-center text-center">
      <h1 className="w-full ">Start Creating Rule</h1>
    </div>
  );
};

export default DisplayStartMsg;
